import { singletonGetter } from "@faire/web/common/singletons/getter";

export type PreloadedImageInfo = {
  img: Pick<HTMLImageElement, "src" | "currentSrc">;
  showVerticalImagery: boolean;
};

export class PreloadedImageTracker {
  static get = singletonGetter(PreloadedImageTracker);

  private preloadedImageMap = new Map<string, PreloadedImageInfo>();

  getInfo = (url: string): PreloadedImageInfo | undefined => {
    const key = getKeyFromUrl(url);
    if (key) {
      return this.preloadedImageMap.get(key);
    } else {
      return undefined;
    }
  };

  setInfo = (url: string, info: PreloadedImageInfo): void => {
    const key = getKeyFromUrl(url);
    if (key) {
      this.preloadedImageMap.set(key, info);
    }
  };

  clear = () => {
    this.preloadedImageMap.clear();
  };
}

function getKeyFromUrl(urlStr: string): string | undefined {
  try {
    const url = new URL(urlStr);
    return url.origin + url.pathname;
  } catch {
    // new URL() will throw an exception if URL is invalid
    return undefined;
  }
}
